import { render, staticRenderFns } from "./ProspectiveProjectsDataTable.vue?vue&type=template&id=5e20f0f6"
import script from "./ProspectiveProjectsDataTable.vue?vue&type=script&lang=js"
export * from "./ProspectiveProjectsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports